<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform" xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <div class="layout-product-youtube">
    <div class="container">
      <iframe
          style="width: 100%"
          :src="path+youtubeid"
          title=""
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen>
      </iframe>

    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    youtubeid: "",
  },
  data() {
    return {
      path: "https://www.youtube.com/embed/",
      window: {
        width: 0,
        height: 0
      }
    }
  },
  mounted() {
    this.disableZoomin();
  },
  methods: {
    handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
    },
  },
  created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
  },
  destroyed() {
      window.removeEventListener('resize', this.handleResize);
  }
}
</script>